var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.9,18c-0.4-0.1-0.4-0.4-0.4-0.7c0-7,0-8.3,0-15.2c0-0.1,0-0.2,0-0.3C8.4,1.8,8.3,1.8,8.2,1.9 C6,4,3.8,6,1.6,8.1C1.5,8.2,1.4,8.2,1.3,8.3C1.1,8.4,0.8,8.4,0.7,8.2C0.5,8.1,0.4,7.8,0.6,7.7c0.1-0.1,0.1-0.2,0.2-0.2 C3.3,5,5.9,2.7,8.5,0.3c0.4-0.4,0.6-0.4,1,0c2.6,2.4,5.1,4.8,7.7,7.2c0.2,0.2,0.3,0.3,0.3,0.6c-0.1,0.3-0.5,0.5-0.8,0.3 c-0.1-0.1-0.2-0.1-0.3-0.2C14.2,6,12,4,9.8,1.9C9.7,1.9,9.7,1.8,9.6,1.7c0,0-0.1,0-0.1,0c0,0.1,0,0.2,0,0.3c0,4.8,0,4,0,8.8 c0,2.2,0,4.4,0,6.5c0,0.3-0.1,0.6-0.4,0.7C9,18,9,18,8.9,18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.88cb02e94482d04163ba260b65e70958.svg";
export { ForwardRef as ReactComponent };